import request from '@/utils/request'

export function login(data) {
  return request({ url: '/login/login', method: 'post', data })
}

export function logout() {
  return request({ url: '/login/logout', method: 'post' })
}
// 获取仪表盘统计数据
export function getDashboard() {
  return request({ url: '/dashboard/dashboard', method: 'get' })
}




// 修改密码
export function changePassword(data) {
  return request({ url: '/change-password', method: 'post', data })
}
